import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'


const initialState = {
    fetchingStatus: 'idle',
    fetchingError: undefined as string | undefined,
    updateStatus: 'idle',
    updateError: undefined as string | undefined,

    contracts: [] as any[],

    rentFetchingStatus: 'idle',
    rentFetchingError: undefined as string | undefined,
    rentUpdateStatus: 'idle',
    rentUpdateError: undefined as string | undefined,
    rents: [] as any[],
    rentsContractId: undefined as number | undefined,
}


export const loadContracts = createAsyncThunk('contracts/loadContracts', async () => {
    const res = await client.get('/api/ixweb/flbel/')
    return res.data
})

export const updateContract = createAsyncThunk('contracts/updateContract', async (data: any) => {
    await client.put(`/api/ixweb/flbel/${data.HDR_ID}/`, data)
    return data
})

export const loadRents = createAsyncThunk('contracts/loadRents', async ({ contractId, objNr, perNr, unitNr, dateFrom, dateTo }: any, thunkApi) => {
    let q = `?objnr=${objNr}&pno=${perNr}&flstmnr=${unitNr}&date_from=${dateFrom}`
    if (dateTo && dateTo !== '') { q = `${q}&date_to=${dateTo}` }

    thunkApi.dispatch(setRentsContractId(contractId))
    const res = await client.get(`/api/ixweb/rent-amounts-redis/${q}`)
    return res.data
})

export const updateRent = createAsyncThunk('contracts/updateRent', async (data: any) => {
    await client.put(`/api/ixweb/rent-amount-redis/${data.HDR_ID}/`, data)
    return data
})

export const newRent = createAsyncThunk('contracts/newRent', async (data: any) => {
    await client.post(`/api/ixweb/rent-amount-redis/`, data)
    return data
})

const contractsSlice = createSlice({
    name: 'contracts',
    initialState,
    reducers: {
        setRentsContractId: (state, action) => {
            state.rentsContractId = action.payload
        },
        resetRentUpdateStatus: (state) => {
            state.rentUpdateStatus = 'idle'
            state.rentUpdateError = undefined
        }
    },
    extraReducers: builder => {
        builder.addCase(loadContracts.pending, (state) => {
            state.fetchingStatus = 'pending'
            state.fetchingError = undefined
        })
        builder.addCase(loadContracts.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            state.fetchingError = undefined
            state.contracts = action.payload
        })
        builder.addCase(loadContracts.rejected, (state, action) => {
            state.fetchingStatus = 'error'
            state.fetchingError = action.error.message
        })

        builder.addCase(updateContract.pending, (state) => {
            state.updateStatus = 'pending'
            state.updateError = undefined
        })
        builder.addCase(updateContract.fulfilled, (state, action) => {
            state.updateStatus = 'idle'
            state.updateError = undefined
            state.contracts = state.contracts.map((c: any) => {
                return c.HDR_ID === action.payload.HDR_ID
                    ? action.payload
                    : c
            })
        })
        builder.addCase(updateContract.rejected, (state, action) => {
            state.updateStatus = 'error'
            state.updateError = action.error.message
        })

        builder.addCase(loadRents.pending, (state) => {
            state.rentFetchingStatus = 'pending'
            state.rentFetchingError = undefined
        })
        builder.addCase(loadRents.fulfilled, (state, action) => {
            state.rentFetchingStatus = 'idle'
            state.rentFetchingError = undefined
            state.rents = action.payload
        })
        builder.addCase(loadRents.rejected, (state, action) => {
            state.rentFetchingStatus = 'error'
            state.rentFetchingError = action.error.message
        })

        builder.addCase(updateRent.pending, (state) => {
            state.rentUpdateStatus = 'pending'
            state.rentUpdateError = undefined
        })
        builder.addCase(updateRent.fulfilled, (state, action) => {
            state.rentUpdateStatus = 'fulfilled'
            state.rentUpdateError = undefined
            state.rents = state.rents.map(r => r.HDR_ID === action.payload.HDR_ID ? action.payload : r)
        })
        builder.addCase(updateRent.rejected, (state, action) => {
            state.rentUpdateStatus = 'error'
            state.rentUpdateError = action.error.message
        })
    }
})

export const { setRentsContractId, resetRentUpdateStatus } = contractsSlice.actions
export default contractsSlice.reducer
